import { useDispatch } from 'react-redux';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { setAppLoader } from '@/redux/common/CommonActions';
import { NOTIFICATION_TYPES, showNotification } from '@/views/components/Modals/notification';

import { deleteClaims } from '../data-provider/delete-claims';
import type { DeleteClaimsRequestParams } from '../data-provider/delete-claims/api';

export interface UseDeleteClaimsOptions {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}

export const useDeleteClaims = (options?: UseDeleteClaimsOptions) => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  return useMutation({
    mutationFn: (params: DeleteClaimsRequestParams) => deleteClaims(params),
    onError: (error: Error) => {
      dispatch(setAppLoader(false));
      showNotification({
        message: 'Failed to delete claims',
        type: NOTIFICATION_TYPES.ERROR,
      });
      options?.onError?.(error);
    },
    onMutate: () => {
      dispatch(setAppLoader(true));
    },
    onSuccess: () => {
      dispatch(setAppLoader(false));

      queryClient.invalidateQueries({ queryKey: ['claims-loss-and-damage-list'] });

      showNotification({
        message: 'Selected claims are deleted successfully',
        type: NOTIFICATION_TYPES.SUCCESS,
      });

      options?.onSuccess?.();
    },
  });
};
